import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import {Helmet} from 'react-helmet-async';
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';


const People = () => {
  const {t, i18n} = useTranslation(['people', 'common', 'title'])
  const isChinese = i18n.language.includes('zh');
  const introduction = t('introduction', {ns: 'people'});
  const co_chairs = t('co_chairs', {ns: 'people', returnObjects: true});
  const expert_members = t('expert_members', {ns: 'people', returnObjects: true});
  const advisory_committee = t('advisory_committee', {ns: 'people', returnObjects: true});
  const anso_organization_members = t('anso_organization_members', {ns: 'people', returnObjects: true});
  const general_contact = t('general_contact', {ns: 'people', returnObjects: true});

  const renderPersonCard = (person, index) => (
    <a
      key={index}
      href={person.link || "javascript:void(0)"}
      target={person.link ? "_self" : undefined}
      rel={person.link ? "noopener noreferrer" : undefined}
      className={`border-b-4 border-[#215ec6] w-full md:w-[600px] lg:w-[800px] mb-16 px-8 py-12 flex flex-col md:flex-row justify-start items-center bg-gray-50 shadow-lg ${
        person.link ? "hover:bg-gray-100 cursor-pointer" : "cursor-default"
      }`}
    >
      <img className="mb-4 w-32 h-32 object-cover rounded-full border-2 border-gray-300 md:mr-12"
           src={process.env.PUBLIC_URL + `/images/people/${person.image}`} alt={person.name}
           style={{objectPosition: 'center top'}}
      />
      <div className="flex flex-col items-center sm:items-start lg:max-w-[75%]">
        <p className="mb-5 text-[#215ec6] font-semibold text-center sm:text-start">{person.role}</p>
        <h3 className="text-3xl font-medium text-gray-800 mb-7">{person.name}</h3>
        <ul className="list-disc list-inside text-gray-600">
          {person.titles.map((title, idx) => (
            <li key={idx}>{title}</li>
          ))}
        </ul>
      </div>
    </a>
  );

  return (
    <div className={"bg-white"}>
      <SEO title={t('people', {ns: 'html_title'})}></SEO>
      <div className={"bg-cover bg-gray-300 bg-blend-multiply bg-right bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
           style={{backgroundImage: `url(${heroBackgroundImage})`}}
      >
        <div className={"flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16"}>
          <div className={`font-bold tracking-[.02em] text-white leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.02em]'}`}>
            {t('hero_heading_1')}
          </div>
        </div>
      </div>
      <div className={"content-container py-24"}>
        {/* Introduction Section */}
{/*        {introduction && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 mb-16"}>
            <p className="text-lg text-gray-700 leading-relaxed text-justify whitespace-pre-line">
              {introduction}
            </p>
          </div>
        )}*/}

        {/* Co-Chairs Section */}
        {co_chairs && co_chairs.length > 0 && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 mb-24"}>
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center border-b-4 border-[#215ec6] pb-4">
              {t('section_heading_1')}
            </h2>
            <div className="flex justify-center gap-4 sm:gap-8 md:gap-16 w-full">
              {co_chairs.map((person, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow w-[180px] sm:w-[250px] md:w-[330px]">
                  <div className="flex flex-col items-center">
                    <img className="w-24 h-24 object-cover rounded-full border-2 border-gray-300 mb-4"
                         src={process.env.PUBLIC_URL + `/images/people/${person.image}`} 
                         alt={person.name}
                         style={{objectPosition: 'center top'}}
                         onError={(e) => {e.target.style.display = 'none'}}
                    />
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">{person.name}</h3>
                    <ul className="text-sm text-gray-600 text-center">
                      {person.titles.map((title, idx) => (
                        <li key={idx} className="mb-1">{title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Expert Group Members Section */}
        {expert_members && expert_members.length > 0 && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 mb-24"}>
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center border-b-4 border-[#215ec6] pb-4">
              {t('section_heading_2')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
              {expert_members.map((person, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex flex-col items-center">
                   <img className="w-24 h-24 object-cover rounded-full border-2 border-gray-300 mb-4"
                         src={process.env.PUBLIC_URL + `/images/people/${person.image}`} 
                         alt={person.name}
                         style={{objectPosition: 'center top'}}
                         onError={(e) => {e.target.style.display = 'none'}}
                    />
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">{person.name}</h3>
                    <ul className="text-sm text-gray-600 text-center">
                      {person.titles.map((title, idx) => (
                        <li key={idx} className="mb-1">{title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Advisory Committee Section */}
        {advisory_committee && advisory_committee.length > 0 && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 mb-24"}>
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center border-b-4 border-[#215ec6] pb-4">
              {t('section_heading_3')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
              {advisory_committee.map((person, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex flex-col items-center">
                    <img className="w-24 h-24 object-cover rounded-full border-2 border-gray-300 mb-4"
                         src={process.env.PUBLIC_URL + `/images/people/${person.image}`} 
                         alt={person.name}
                         style={{objectPosition: 'center top'}}
                         onError={(e) => {e.target.style.display = 'none'}}
                    />
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">{person.name}</h3>
                    <ul className="text-sm text-gray-600 text-center">
                      {person.titles.map((title, idx) => (
                        <li key={idx} className="mb-1">{title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ANSO Organization Members Section */}
        {anso_organization_members && anso_organization_members.length > 0 && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 mb-24"}>
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center border-b-4 border-[#215ec6] pb-4">
              {t('section_heading_5')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
              {anso_organization_members.map((person, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex flex-col items-center">
                    <img className="w-24 h-24 object-cover rounded-full border-2 border-gray-300 mb-4"
                         src={process.env.PUBLIC_URL + `/images/people/${person.image}`} 
                         alt={person.name}
                         style={{objectPosition: 'center top'}}
                         onError={(e) => {e.target.style.display = 'none'}}
                    />
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">{person.name}</h3>
                    <ul className="text-sm text-gray-600 text-center">
                      {person.titles.map((title, idx) => (
                        <li key={idx} className="mb-1">{title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* General Contact Section */}
        {general_contact && general_contact.length > 0 && (
          <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 pb-36"}>
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center border-b-4 border-[#215ec6] pb-4">
              {t('section_heading_4')}
            </h2>
            <div className="flex justify-center gap-4 sm:gap-8 md:gap-16 w-full">
              {general_contact.map((person, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow w-[180px] sm:w-[250px] md:w-[330px]">
                  <div className="flex flex-col items-center">
                    <img className="w-24 h-24 object-cover rounded-full border-2 border-gray-300 mb-4"
                         src={process.env.PUBLIC_URL + `/images/people/${person.image}`} 
                         alt={person.name}
                         style={{objectPosition: 'center top'}}
                         onError={(e) => {e.target.style.display = 'none'}}
                    />
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">{person.name}</h3>
                    <ul className="text-sm text-gray-600 text-center">
                      {person.titles.map((title, idx) => (
                        <li key={idx} className="mb-1">{title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default People;
